import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import Loader from 'components/elements/Loader';
import { FlexDiv, FlexColumnCenterAlign } from 'resources/styles/display';

import PDFNavigation from './PDFNavigation';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface FinalReportScreenProps {
  pdf?: Blob;
}

const FinalReportScreen: React.FC<FinalReportScreenProps> = ({ pdf }) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);

  if (!pdf) return <Loader />;

  return (
    <FlexColumnCenterAlign style={{ marginTop: '1.5rem' }}>
      <PDFNavigation
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={setCurrentPage}
      />
      <FlexDiv>
        <Document
          file={pdf}
          onLoadSuccess={({ numPages }) => setTotalPages(numPages)}
        >
          <Page
            height={800}
            pageNumber={currentPage}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </FlexDiv>
    </FlexColumnCenterAlign>
  );
};

export default FinalReportScreen;
